<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <div>
            <strong>{{ title }}</strong>
          </div>

          <div class="p-grid">
            <div class="p-col-3">
              <label for="codeSystem" class="p-col-fixed style_label_filter" style="">Ngày hoàn thành VB:</label>
              <div class="p-col">
                <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
              </div>
            </div>
            <div class="p-col-3">
              <label for="codeSystem" class="p-col-fixed style_label_filter" style="">Mã TDV:</label>
              <div class="p-col">
                <InputText id="codeTDV" type="text" v-model="codeTDV" placeholder="Nhập TDV"/>
              </div>
            </div>
            <div class="p-col-3">
              <label for="codeSystem" class="p-col-fixed style_label_filter" style="">Mã VPLK:</label>
              <div class="p-col">
                <InputText id="codeVPLK" type="text" v-model="codeVPLK" placeholder="Nhập mã VPLK"/>
              </div>
            </div>
            <div class="p-col-3">
              <div style="height: 100%;position: relative">
                <Button style="position:absolute;bottom: 8px" label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>
              </div>
<!--              <label  class="p-col-fixed" style=""> </label>
              <div class="p-col">
                <Button label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>
              </div>-->
            </div>
          </div>
<!--          <div style="display: block; float:left;">
            <span class="" style="">Ngày hoàn thành VB: </span>
            <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
            <label for="codeTDV" class="p-col-fixed">Mã TDV:</label>
            <InputText id="codeTDV" type="text" v-model="codeTDV" placeholder="Nhập TDV"/>
            <label for="codeVPLK" class="p-col-fixed">Mã VPLK:</label>
            <InputText id="codeVPLK" type="text" v-model="codeVPLK" placeholder="Nhập mã VPLK"/>
          </div>
          <Button label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>-->

          <div style="display: inline;">
            <div class="box-selected-file" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document_province.export == true || this.$store.getters.role == 'admin'">
              <ExportExcel
                :fields="exportConfigs.fields"
                :fetch="exportConfigs.fetch"
                :colHeaderStyle="exportConfigs.colHeaderStyle"
                :name="exportConfigs.name"
                :subTitle="exportConfigs.subTitle"
              >
                <span class="btn-span">Xuất Excel</span>
              </ExportExcel>
            </div>
            <Button label="Xác nhận tính lương" @click="onComputeDeadline" class="p-button-danger" :disabled="selectedRows == null || selectedRows.length == 0" style="float: right; padding: 5px 20px; margin: 1px 20px 0 0;"/>
          </div>
          
        </div>
        <Dialog
            header="XÁC NHẬN"
            :visible.sync="showOnTimeDialog"
            :contentStyle="{overflow: 'visible'}"
            :modal="true"
        >
          <strong>Bạn có chắc chắn muốn tính lương các văn bản đã chọn?</strong>
          <div class="p-fluid" style="margin-top: 16px">
            <div class="p-grid">
              <div class="p-col-12">
                <div style="display: block">
                  <label>Lương tháng<span class="error">*</span></label>
                </div>
                <div class="p-field">
                  <Calendar v-if="hide_calenda ==true"  v-model="date_comfirm_salary_key" dateFormat="dd/mm/yy" :showButtonBar="true"  :showIcon="true"/>
                </div>
              </div>
            </div>
          </div>
          <template
              #footer
          >
            <div style="text-align: center">
              <Button label="Hủy" @click="showOnTimeDialog = false" icon="pi pi-times" class="p-button-warning"/>
              <Button label="Xác nhận" @click="onConfirm" icon="pi pi-check" class="p-button-success" />
            </div>
          </template>
        </Dialog>

        <DataTable
          :value="listData"
          class="p-datatable-responsive"
          dataKey="id"
          :selection.sync="selectedRows"
          :paginator="pagination"
          :rows="paginationRows"
          :loading="loading"
          :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) "
          :scrollHeight="scrollHeight"
          :autoLayout="true"
          :key="componentKey"
          :rowsPerPageOptions="rowsPerPageOptions"
          currentPageReportTemplate="Tổng số văn bản: {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <Column 
            v-for="c in dataModel.getDisplayFields()"
            :key="c.key"
            :field="getField(c)"
            :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)"
            :filterFunction="customFilter"
            :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')"
            :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)"
            :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                v-if="getType(c) == 'Image'"
                :src="getData(c, slotProps.data)"
                style="width: 40px; heigth: 40px"
              />
              <div
                v-else-if="c.type == 'Text'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="c.type == 'Currency'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div class="" style="display: inline-flex" v-else-if="c.type == 'InputCurrency'">
                <div class="amount-salary">
                  <!--{{slotProps.data.is_confirm_salary}}-->
                  <InputNumber
                    :min="0" v-bind:value="getData(c, slotProps.data) ? getData(c, slotProps.data) : 0"
                    mode="currency"
                    currency="VND"
                    locale="vi-VN"
                    @input="changeSalary($event, slotProps.data)"
                  />
                </div>
                <div class="">
                  <Button :disabled="slotProps.data.is_confirm_salary == true"  icon="pi pi-check" class="p-button-danger" iconPos="center" @click="onChangeSalary($event, slotProps.data)" style="padding: 11px;"/>
                </div>
              </div>

              <Checkbox
                v-else-if="getType(c) == 'Checkbox'"
                v-model="slotProps.data[slotProps.column.field]"
                :disabled="true"
                :binary="true"
                @change="onInputChange($event, slotProps.data, c)"
              />
              <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
            </template>
            <template v-if="c.filter" #filter>
              <InputText
                v-if="c.filter.type == 'input'"
                type="text"
                v-model="filters[c.key]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
              />
              <Dropdown
                :key="countDropdown"
                v-if="c.filter.type == 'select'"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
              >
                <template #option="slotProps">
                  <div class="p-clearfix">
                    <span
                      :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                      >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                  </div>
                </template>
              </Dropdown>
              <!--<Calendar
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false" 
                :monthNavigator="true" 
                :yearNavigator="true" 
                yearRange="2000:2030" 
                dateFormat="yy-mm-dd" 
                id="date_from" 
                v-model="filters[getField(c)]" 
                class="p-column-filter"
                :showIcon="true" 
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,getField(c))"
                :manualInput="false"
                />-->
              <Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'from'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'from')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Từ ngày'"
                  @date-select="selectChangeDate($event, c, 'from')"
                  @clear-click="clearChangeDate( c, 'from')"

              />
              <Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'to'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'to')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Đến ngày'"
                  @date-select="selectChangeDate($event, c, 'to')"
                  @clear-click="clearChangeDate(c, 'to')"
              />
            </template>
          </Column>
          <!-- <Column
            v-if="getRowActions()"
            headerStyle="width: 8em; text-align: center"
            bodyStyle="width: 8em; text-align: center"
          >
            <template #body="slotProps">
              <span class="p-column-title">Actions</span>
              {{ slotProps.data.color }}
              <Button
                v-for="(a, k) in getRowActions().rows(slotProps.data)"
                :key="k"
                type="button"
                :icon="getIcon(a.icon)"
                :class="getClass(a.name)"
                :disabled="getDisabled(a.disabled)"
                style="margin-right: 0.5em;"
                v-on:click="actionsClicked(k, a, slotProps)"
              ></Button>
            </template>
            <template #header="slotProps">
              <Button
                v-if="getRowActions().header"
                type="button"
                :icon="getIcon(getRowActions().header.icon)"
                :class="getClass(getRowActions().header.name)"
                v-on:click="actionsClicked(getRowActions().header.name, getRowActions().header, slotProps)"
              ></Button>
            </template>
          </Column> -->
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
        </DataTable>

        <Dialog
          header="XÁC NHẬN"
          :visible.sync="showConfirmDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <strong>Bạn có chắc chắn muốn tính lương các văn bản này?</strong>
          <template
            #footer
          >
            <div style="text-align: center">
              <Button label="Hủy" @click="showConfirmDialog = false" icon="pi pi-times" class="p-button-warning"/>
              <Button label="Xác nhận" @click="onConfirmSalary" icon="pi pi-check" class="p-button-success" />
            </div>
          </template>
        </Dialog>

      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
// import XLSX from "xlsx"
import graphql from '../common/graphql'
// import jsPDF from "jspdf"
// import JsBarcode from 'jsbarcode'
import 'jspdf-autotable'
import store from '@/store'
export default {
  components: {
  },
  data() {
    return {
      date_comfirm_salary_key:null,
      hide_calenda:false,
      dateType:0,
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      showConfirmDialog: false,
      showOnTimeDialog: false,
      totalDoc: 0,
      filterDate: null,
      codeTDV: '',
      codeVPLK: '',
      dateFrom: null,
      dateTo: null,
      deadline: false,
      // 
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      selectedRows: null,
      // EXPORT
      exportConfigs: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        subTitle: () => {
          let subTitle = '';
          let dateFrom = '...';
          let dateEnd = '...';
          // console.log(data);
          if (this.filterDate !== null) {
            dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : dateFrom;
          }

          subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
          return subTitle;
        },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        fields: {
          'STT  ': 'stt',
          'MÃ SỐ': 'code_system',
          'MÃ VB CỦA TÒA': 'code_court',
          'TÊN': 'name_litigant',
          'ĐỊA CHỈ': 'address',
          'PHƯỜNG/ XÃ': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.ward)) ? row.ward.name:'';
            }
          },
          'QUẬN/ HUYỆN': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.district)) ? row.district.name:'';
            }
          },
          'TP/ TỈNH': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.state)) ? row.state.name:'';
            }
          },
          'MÃ CƠ QUAN': 'code_agency',
          'NGÀY NHẬN TÒA': {
            field: 'date_receipt_court',
            callback: (value) => {
              if (value)
                return moment
                  .utc(value)
                  .clone()
                  .tz('Asia/Ho_Chi_Minh')
                  .format('DD/MM/YYYY');
            },
          },
          'NGÀY TRẢ TÒA': {
            field: 'date_return_court',
            callback: (value) => {
              if (value)
                return moment
                  .utc(value)
                  .clone()
                  .tz('Asia/Ho_Chi_Minh')
                  .format('DD/MM/YYYY');
            },
          },
          'HỌ TÊN': {
            callback: (row) => {
              return row.tdv && row.tdv.fullname || ''
            }
          },
          'NGÀY NHẬN': {
            field: 'date_tdv_receipt',
            callback: (value) => {
              if (value)
                return moment
                  .utc(value)
                  .clone()
                  .tz('Asia/Ho_Chi_Minh')
                  .format('DD/MM/YYYY');
            },
          },
          'NGÀY TRẢ': {
            field: 'date_tdv_return',
            callback: (value) => {
              if (value)
                return moment
                  .utc(value)
                  .clone()
                  .tz('Asia/Ho_Chi_Minh')
                  .format('DD/MM/YYYY');
            },
          },
          'HÌNH THỨC TĐ': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.status_tongdat)) ? row.status_tongdat.name:'';
            }
          },
          'TRẠNG THÁI VB': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.status_document)) ? row.status_document.name:'';
            }
          },
          // 'GIÁ VB CƠ QUAN TRẢ': 'cost_document',
          'GHI CHÚ(lý do)': 'note',
          'GIÁ VB CƠ QUAN TRẢ': {
            callback: (row) => {
              return row.cost_document
            }
          },
          'CHI PHÍ TÍNH LƯƠNG': {
            callback: (row) => {
              return row.amount_salary
            }
          },
        },
        fetch: async () => {
          let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            let objWhere = {
              id: {'_in': arrIDs}
            }
            if (this.filterDate !== null) {
              let date1 = new Date(this.filterDate[0]).toISOString()
              date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
              let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1;
              date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
              Object.assign(objWhere, {date_receipt_court: {'_gte': date1, '_lte': date2}})
            }
            if (this.codeTDV !== '' && this.codeTDV !== null) {
              Object.assign(objWhere, {tdv: {code: {'_eq': this.codeTDV}}})
            }
            if (this.codeVPLK !== '' && this.codeVPLK !== null) {
              Object.assign(objWhere, {office_vplk: {code: {'_eq': this.codeVPLK}}})
            }
            await this.$apollo.query({
              query: gql(graphql.GET_DOCUMENT_PROVINCE),
              variables: {
                where: objWhere,
                orderBy: {id: 'asc'}
              },
              fetchPolicy: "no-cache"
            }).then(async (resData) => {
              // console.log("=============fetch data", resData)
              let lstdata = resData.data.document;
              for (let i = 0; i < lstdata.length; i++) {
                lstdata[i].stt = i + 1;
                data.push(lstdata[i]);
              }
            }).catch((error) => {
              console.log(error);
            });
            // console.log("Fecth return", data)
            if (data.length > 0) {
              this.selectedRows = null;
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              return data;
            } else {
              this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Xuất file không thành công', life: 3000 })
              return data;
            }
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 văn bản', life: 3000 })
            return data;
          }
        },
        name: 'Xuất Excel.xls',
      }
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.list_document_province.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('compute_salary_outbound')
    this.title = this.dataModel.label
    this.$store.commit('setLoading', true);
    // if(this.$route.params.reload) {
    //   window.location.reload();
    // }
    this.loading = false;
    this.countDropdown++;
    this.$apollo.queries.listData.refresh();
    // await this.onCreated();
    this.callbackOptions()
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    async onCreated() {
      if (this.filterDate !== null) {
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1;
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
      }
      // console.log(this.dateFrom)
      // console.log(this.dateTo)
      var objWhere = {
        date_receipt_court: {'_gte': this.dateFrom, '_lte': this.dateTo},
        deleted: {'_eq': false},
        //state_id: {'_neq': 9}
        state: {type: {_eq: this.$constants.TYPE_STATE.URBAN}}
      }
      if (this.codeTDV !== '' && this.codeTDV !== null) {
        Object.assign(objWhere, {tdv: {code: {'_eq': this.codeTDV}}})
      }
      if (this.codeVPLK !== '' && this.codeVPLK !== null) {
        Object.assign(objWhere, {office_vplk: {code: {'_eq': this.codeVPLK}}})
      }
      // console.log(objWhere);
      await this.$apollo.query({
        query: gql(graphql.GET_DOCUMENT_PROVINCE),
        variables: {
          where: objWhere,
          orderBy: {id: 'desc'}
        },
        fetchPolicy: 'network-only'
      }).then((res) => {
        // console.log(res)
        this.listData = [];
        if (res && res.data && res.data.document.length > 0) {
          this.listData = [...res.data.document]
          this.dataModel.processData(this.listData)
        }
        this.$store.commit('setLoading', false);
      }).catch((error) => {
        this.$store.commit('setLoading', false);
        console.log(error)
      })
    },
    async onEnter() {
      this.$store.commit('setLoading', true);
      if (this.filterDate !== null) {
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
      }
      await this.onCreated();
    },
    async onComputeDeadline() {
      this.showOnTimeDialog = true;
      this.common_dateTsalary();
    },
    async common_dateTsalary() {
      this.date_comfirm_salary_key=new Date(moment().subtract(1, 'months'));
      var that =this;
      that.hide_calenda= false;//ẩn để ko bị focus vào calenda
      setTimeout(function () {
        that.hide_calenda= true;
      }, 100)
    },
    async onConfirm() {
      this.$store.commit('setLoading', true);
      let arrIDs = []
      // CHỈ UPDATE VĂN BẢN CHƯA UPDATE THÀNH TRẠNG THÁI TÍNH LƯƠNG.
      if (this.selectedRows && this.selectedRows.length > 0) {
        //console.log("his.selectedRowshis.selectedRowshis.selectedRows:",this.selectedRows)
        for (let i = 0; i < this.selectedRows.length; i++) {
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].status_document.code !== 'SALARY' && !this.listData[j].is_confirm_salary) {
              arrIDs.push({
                id: this.listData[j].id,
                state_id: this.listData[j].state_id,
                office_vplk_id: this.listData[j].vplk_id,
                office_tpl_id: (this.listData[j].office_tpl) ? this.listData[j].office_tpl.id:null,
                status_td_id: this.listData[j].status_tongdat && this.listData[j].status_tongdat.id || null,
                date_receipt_court: this.listData[j].date_receipt_court
              })
            }
          }
        }
      }
      // console.log(arrIDs);
      //code này ko xài
      if (arrIDs.length > 0) {
        //console.log("arrIDsarrIDsarrIDs:",arrIDs)
        for (let k = 0; k < arrIDs.length; k++) {
          //var amountSalary = 0;
          await this.$apollo.query({
            query: gql(graphql.GET_ORGAN_PRICELIST_PROVINCE),
            variables: {
              where: {
                office_vplk_id: {'_eq': arrIDs[k].office_vplk_id},
                office_tpl_id: {'_eq': arrIDs[k].office_tpl_id},
                state_id: {'_eq': arrIDs[k].state_id}
              },
              limit: 1
            }
          }).then(async (res) => {
            if (res.data && res.data.salary_pricelist_province.length > 0) {
              //let item = res.data.salary_pricelist_province[0];
              await this.checkDeadline(arrIDs[k].status_td_id, arrIDs[k].date_receipt_court);
              /*if (!this.deadline) {
                // CHỈ ĐÚNG HẸN MỚI TÍNH LƯƠNG VB ĐI TỈNH
                amountSalary = item.price
              }*/
            }
          })
          // 
          let variables = {
            'data_update': {
              status_vb_id: 8, // VB TÍNH LƯƠNG
              is_confirm_salary: true,
              date_comfirm_salary: (this.date_comfirm_salary_key).toISOString(),
              date_upd_salary: (new Date()).toISOString(),
              //amount_salary: amountSalary,//Xác nhận lương sẽ ko thay đổi lương , nên ko update
              deadline_color: 0
            },
            'where_key': {
              id: {'_eq': arrIDs[k].id}
            }
          };
          await this.$apollo.mutate({
            mutation: DataServices.updateData('document'),
            variables: variables
          }).then(async (res) => {
            if (res.data[Object.keys(res.data)].affected_rows) {
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
              this.$store.commit('setLoading', false);
            }
          }).catch((error) => {
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 3000 })
            console.error('ERROR: ', error)
            // this.selectedRows = null
            this.$store.commit('setLoading', false);
          });
        }
        this.selectedRows = null
        this.$apollo.queries.listData.refresh();
        this.showOnTimeDialog =false;
        this.$store.commit('setLoading', false);
      } else {
        this.selectedRows = null
        this.$store.commit('setLoading', false);
      }
    },
    async checkDeadline(statusID, dateReceiptCourt) {
      if (statusID == null) statusID = 1;
      let denta = moment().diff(moment(new Date(dateReceiptCourt), 'DD-MM-YYYY'), 'days');
      // console.log('====>DENTA: ', denta);
      await this.$apollo.query({
        query: gql(graphql.GET_STATUS_TONGDAT),
        variables: {
          where: {
            id: {'_eq': statusID}
          },
          limit: 1
        }
      }).then((res) => {
        this.deadline = false;
        if (res.data.status_tongdat.length > 0) {
          let item = res.data.status_tongdat[0];
          if (denta > item.delay_time) this.deadline = true;
        }
      }).catch((error) => {
        console.error('ERROR: ', error);
      })
    },
    changeSalary(e, data) {
      // console.log(e, data)
      let salary = 0
      if (e) {
        salary = e
      }
      data.amount_salary = salary
    },
    async onChangeSalary(e, data) {
      // console.log('-------------------', e, data)
      this.$store.commit("setLoading", true);
      let amount = 0
      if (data) {
        amount = data.amount_salary
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_DOCUMENT),
        variables: {
          objWhere: {
            id: {'_eq': data.id}
          },
          objInput: {
            amount_salary: amount
          }
        }
      }).then(async (res) => {
        if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
          this.$toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Lưu dữ liệu thành công",
            life: 3000
          });
          this.$apollo.queries.listData.refresh();
          this.$store.commit("setLoading", false);
        } else {
          this.$store.commit("setLoading", false);
          this.$toast.add({
            severity: "error",
            summary: "Thất bại",
            detail: "Lưu dữ liệu thất bại",
            life: 3000
          });
        }
      }).catch((error) => {
        console.error('ERROR: ', error)
      })
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('statement_return_court');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          var tableName = element.models.tableName
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `statement-return-court/edit/`}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        // buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    onExportExcel(e) {
      console.log('Xuat file: ', this.selectedRows)
      this.$store.commit("setLoading", true);
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (files[0].name.split('.').pop() !== 'xlsx' && files[0].name.split('.').pop() !== 'XLSX') {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng nhập file có định dạng xlsx', life: 3000 })
        return
      }
      this.$store.commit("setLoading", false);
    },
    // GỘP HÀM
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        else if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        else if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        else {
          value = row[col.key];
        }
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },

    customFilter( itemLabel, filterValue) {
      return this.$CoreService.customFilterCore(itemLabel, filterValue , this.dateType);
    },
    onFilterDate(payload) {
      if (payload.col.filter.type == 'Date') this.dateType = 1;
      else if (payload.col.filter.type == 'DateRange') this.dateType = 2;
      else this.dateType = 0;
      if (payload.type != undefined && payload.type != '' && (payload.type == 'from' || payload.type == 'to')) {
        if (this.filters[payload.col.key] == undefined ) this.filters[payload.col.key] = {};
        if (payload.data != undefined) {
          this.filters[payload.col.key][payload.type] = payload.data;
          if (this.filters[payload.col.key] != null && this.filters[payload.col.key]['from'] != null && this.filters[payload.col.key]['to'] != null) {
            var date1 = new Date(moment(this.filters[payload.col.key]['from']).format('YYYY-MM-DD'));
            var date2 = new Date(moment(this.filters[payload.col.key]['to']).format('YYYY-MM-DD'));
            if (Number(date1) > Number(date2)) {
              var dateTemp = this.filters[payload.col.key]['from'];
              this.filters[payload.col.key]['from'] = this.filters[payload.col.key]['to'];
              this.filters[payload.col.key]['to'] = dateTemp;
            }
          }
        }
        else delete this.filters[payload.col.key][payload.type];
      } else {
        this.filters[payload.col.key] = payload.data;
      }
      //croll lại vị trí filter
      this.$commonFuction.scroll_back_filter(payload.col.key+payload.type);
      this.componentKey = Math.random() * 320;
    },
    selectChangeDate(event, col, type = '') {
      var payload = {
        data: event,
        col: col,
        type: type,
        format: this.$commonFuction.formatDateCalenda('Date')
      }
      this.onFilterDate(payload);
    },
    clearChangeDate(col, type = '') {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (type == '') delete this.filters[this.getField(col)];
        else if (type != '' && date[type] != undefined && date[type] != null) delete this.filters[this.getField(col)][type];
      }
      var payload = {
        col: col,
        type: type,
      }
      this.onFilterDate(payload);
    },
    getValueDateRange(col, target) {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (target != '') {
          if (date[target] != undefined && date[target] != null) {
            return moment(date[target]).format(this.$commonFuction.formatDateCalenda('Date'));
          }
        } else return moment(date).format(this.$commonFuction.formatDateCalenda('Date'));
      }
      return null;
    },
  },
  apollo: {
    listData: {
      query() {
        this.modelName = this.$route.meta.model;
        return DataServices.getList(this.modelName);
      },
      variables() {
        return {
          where_key: {
            _or: [
              { state: { type: { _eq: this.$constants.TYPE_STATE.OUTSIDE } } },
              { type_document: { _eq: 5 } }
            ],
            status_document: {
              deleted: {'_eq': false}
            },
            deleted: {'_eq': false},
            //state_id: {'_neq': 9}
            // state: {type: {_eq: this.$constants.TYPE_STATE.OUTSIDE}}
          },
          orderBy: {id: 'desc'}
        }
      },
      /*variables: {
        where_key: {
          status_document: {
            deleted: {'_eq': false}
          },
          deleted: {'_eq': false},
          //state_id: {'_neq': 9}
          state: {type: {_eq: this.$constants.TYPE_STATE.OUTSIDE}}
        },
        orderBy: {id: 'desc'}
      },*/
      update(data) {
        var listData = data[this.dataModel.tableName]
        // console.log(listData)
        this.title = this.dataModel.label + ' '
        this.dataModel.processData(listData)
        this.$store.commit('setLoading', false);
        this.componentKey += 1
        return data[this.dataModel.tableName]
      },
      fetchPolicy: 'network-only',
      error() {
        this.$store.commit('setLoading', false);
      },
      skip() {
        return !this.modelName
      }
    }
  }

}
</script>
<style lang="scss">
/*body{
  overflow-x: hidden;
}*/
.p-datepicker { top: 0px !important;}
.p-calendar .p-datepicker { padding: 0px !important; min-width: 100% !important;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-right: 1px solid #d8dae2 !important;
  padding-left: 0.857rem !important;
  padding-right: 0.857rem !important;
  background: #fff !important;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  border: 1px solid #c8c8c8 !important;
}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
  }
  .title-filter {
    // margin-left: 24px;
  }
  .btn-enter-filter {
    background-color: #0A84FF !important;
    margin-top: 1px;
    margin-left: 10px;
    padding: 6px 30px;
  }
}
.box-selected-file {
  // padding: 10px; 
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
}
.amount-salary {
  .p-inputnumber-input {
    width: 100px !important;
  }
}
/*Fix bug lỗi scroll ngang do position checkbox*/
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}
.style_label_filter{
  padding-bottom: 0px;
  margin-bottom: 0px;
}
</style>